// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { styledTitleStyles } from "@conklin/App/Components/StyledTitle/StyledTitle";
import { color, getSystemColor, linkArrowStyle, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

styledTitleStyles.container = {
    css: css`
        display: flex;
        gap: 32px;
        align-items: baseline;

        ${({ showBottomBorder }: any) => {
            if (showBottomBorder) {
                return css`
                    border-bottom: 1px solid ${color("common.border")};
                `;
            }
        }}
        ${({ buttonAlignment }: any) => {
            if (buttonAlignment === "right") {
                return css`
                    justify-content: space-between;
                `;
            }
        }}
        ${({ titleContentSpace }: any) => {
            if (titleContentSpace) {
                return css`
                    margin-bottom: ${titleContentSpace}px;
                `;
            }
        }}

        ${xScreen("lte", "sm")} {
            flex-direction: column;
            gap: 16px;
            align-items: flex-start;
            padding-bottom: 12px;
        }
    `,
};

styledTitleStyles.leftSide = {
    css: css`
        display: flex;
        align-items: center;
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

styledTitleStyles.title = {
    forwardAs: "p",
    css: css`
        margin-bottom: 0;
        display: flex;
        flex-wrap: nowrap;
        position: relative;
        border-radius: 2px 0 0 2px;
        gap: 12px;
        align-items: center;
        ${({ showTitleIcon }: any) => {
            if (showTitleIcon) {
                return css`
                    &:not(:empty):before {
                        content: "";
                        display: inline-block;
                        border-width: 13px;
                        border-color: ${getSystemColor("primary")};
                        border-left-color: transparent;
                        border-bottom-color: transparent;
                        border-style: solid;
                    }
                `;
            }
        }}
    `,
};

styledTitleStyles.link = linkArrowStyle("large", {
    css: css`
        align-self: baseline;

        ${xScreen("lte", "sm")} {
            align-self: flex-start;
        }
    `,
});

styledTitleStyles.smallLink = linkArrowStyle("small", {
    css: css`
        align-self: baseline;
        ${xScreen("lte", "sm")} {
            align-self: flex-start;
        }
    `,
});
